import {
	Button,
	Checkbox,
	FormControlLabel,
	ListItemSecondaryAction,
	Switch,
	TextField,
	Typography,
} from '@mui/material'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import { FormikErrors, useFormik } from 'formik'
import React from 'react'
import { t } from '../../../locale'
import { EditEventExField } from '../../../types'

type Fields = EditEventExField
type Props = {
	initialValues: Fields
	disabled: boolean
	handleSubmit: (fields: Fields) => void
}

const EditCo2EventForm = (props: Props) => {
	const { disabled, initialValues } = props

	const {
		values,
		errors,
		touched,
		handleChange,
		handleSubmit,
		setFieldTouched,
		setFieldValue,
	} = useFormik<Fields>({
		initialValues,
		validate: (_values) => {
			const errors: FormikErrors<Fields> = {}

			return errors
		},
		onSubmit: (fields: Fields) => {
			props.handleSubmit(fields)
		},
	})

	const change = (name: keyof Fields, e: React.ChangeEvent<unknown>) => {
		e.persist()
		handleChange(e)
		setFieldTouched(name, true, false)
	}

	return (
		<div>
			<Typography variant="h6">{t.event.base}を編集</Typography>
			<FormControlLabel
				control={
					<Switch
						checked={values.enabled}
						onChange={change.bind(null, 'enabled')}
						name="enabled"
						color="primary"
					/>
				}
				label="有効にする"
			/>
			<List style={{ background: values.enabled ? 'white' : '#ddd' }}>
				<ListItem>
					<ListItemText primary={'CO2(以下)'} />
					<ListItemSecondaryAction>
						<TextField
							type="number"
							name="co2Above"
							value={values.co2Above}
							disabled={disabled}
							error={touched.co2Above && Boolean(errors.co2Above)}
							helperText={touched.co2Above && errors.co2Above}
							inputProps={{ min: 0 }}
							onChange={change.bind(null, 'co2Above')}
						/>
					</ListItemSecondaryAction>
				</ListItem>
				<ListItem divider>
					<ListItemText primary={'窓が開いている場合はオフ'} />
					<Checkbox
						checked={values.windowCheck}
						onChange={(e, v) => setFieldValue('windowCheck', v)}
					/>
				</ListItem>
			</List>
			<div style={{ textAlign: 'right' }}>
				<Button onClick={() => handleSubmit()} color="primary" size={'large'}>
					変更する
				</Button>
			</div>
		</div>
	)
}

export default EditCo2EventForm
